import React, { createContext, useContext, ReactNode } from 'react';
import { TenantConfig } from '../types/tenant';
import { useSupabaseTenant } from '../hooks/useSupabaseTenant';
import { getTenantFromHost } from '../lib/tenant';

interface TenantContextType {
  tenant: TenantConfig | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

const TenantContext = createContext<TenantContextType | undefined>(undefined);

export const TenantProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  // Get current subdomain/tenant
  const currentSubdomain = getTenantFromHost();
  
  console.log('🏗️ TenantProvider - Current subdomain:', currentSubdomain);
  
  // Fetch tenant data
  const { 
    tenant, 
    isLoading, 
    error, 
    refetch 
  } = useSupabaseTenant(currentSubdomain || '', {
    enabled: !!currentSubdomain && currentSubdomain !== 'admin'
  });

  return (
    <TenantContext.Provider value={{
      tenant,
      isLoading,
      error,
      refetch
    }}>
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within TenantProvider');
  }
  return context;
};